// third-party
import { Rect } from 'konva/lib/shapes/Rect';
import { Group } from 'konva/lib/Group';
import { Layer } from 'konva/lib/Layer';
// first-party
import { TLElement } from './TLElement';
import ProjectJaeger from '../ProjectJaeger';
// styles
import colours from 'src/styles/variables.module.scss';

export default class TLHighlightGroup extends TLElement {
    public group: Group;
    public bar: Rect;
    public parent: ProjectJaeger;
    public width: number;
    public height: number;
    public barX: number;
    public mainLayer: Layer;

    constructor(parent: ProjectJaeger) {
        super();
        this.parent = parent;
        this.width = parent.context.width;
        this.height = parent.props.context.height;
        this.barX = 0;
        this.mainLayer = parent.mainLayer;
    }

    public create(): void {
        this.group = new Group({
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            perfectDrawEnabled: false,
            bwType: 'highlightGroup'
        });

        this.bar = new Rect({
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            perfectDrawEnabled: false,
            shadowForStrokeEnabled: false,
            fill: colours.highlightBar
        });
        this.group.add(this.bar);

        this.hide();
        this.mainLayer.add(this.group);
    }

    public hide(): void {
        this.group.hide();
    }

    public show(barWidth: number, barX: number): void {
        // set values
        this.width = barWidth;
        this.barX = barX;
        // update group
        this.group.x(this.barX);
        this.group.width(this.width);
        // update bar
        this.bar.width(this.width);
        // show group
        this.group.show();
    }

    public destroy(): void {
        this.group.destroyChildren();
        this.bar = null;
        this.group.destroy();
        this.group = null;
    }

    public update(): void {
        this.width = this.parent.context.width;
        this.height = this.parent.props.context.height;
        this.group.width(this.width);
        this.group.height(this.height);
        this.bar.width(this.width);
        this.bar.height(this.height);
    }

    public remove(): void {}

    public updateX(): void {}

    public updateY(): void {}
}
